export const FETCH_OTP_VERIFIED_DELIVERY_CHARGES_REQUEST = "FETCH_OTP_VERIFIED_DELIVERY_CHARGES_REQUEST";
export const FETCH_OTP_VERIFIED_DELIVERY_CHARGES_SUCCESS = "FETCH_OTP_VERIFIED_DELIVERY_CHARGES_SUCCESS";
export const FETCH_OTP_VERIFIED_DELIVERY_CHARGES_FAILURE = "FETCH_OTP_VERIFIED_DELIVERY_CHARGES_FAILURE";
export const FETCH_OTP_VERIFIED_DELIVERY_CHARGES_RESET = "FETCH_OTP_VERIFIED_DELIVERY_CHARGES_RESET";
export const fetchOTPverifiedDeliveryChargesRequest = (payload) => ({
    type: FETCH_OTP_VERIFIED_DELIVERY_CHARGES_REQUEST,
    payload,
});
export const fetchOTPverifiedDeliveryChargesSuccess = (payload) => ({
    type: FETCH_OTP_VERIFIED_DELIVERY_CHARGES_SUCCESS,
    payload,
});
export const fetchOTPverifiedDeliveryChargesFailure = (payload) => ({
    type: FETCH_OTP_VERIFIED_DELIVERY_CHARGES_FAILURE,
    payload,
});
export const fetchOTPverifiedDeliveryChargesReset = () => ({
    type: FETCH_OTP_VERIFIED_DELIVERY_CHARGES_RESET,
});
